import { API_URL } from '../const'
import { useQuery } from '@tanstack/react-query'
import axios from 'axios'
import { useAuthUser } from 'use-eazy-auth'


export async function getUser(
  token: string,
  signal?: AbortSignal
) {



  return (
    await axios.get(`${API_URL}/oauth/me/`, {
      signal,
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    })
  ).data
}

export function useUser() {
  const { token } = useAuthUser()

  return useQuery({
    queryKey: ['user-refresh'],
    queryFn: ({ signal }) => getUser(token, signal),
    keepPreviousData: true,
    suspense: false,
    enabled: !!token,
  })
}